export var SortDirection;
(function (SortDirection) {
    SortDirection["asc"] = "asc";
    SortDirection["ASC"] = "ASC";
    SortDirection["desc"] = "desc";
    SortDirection["DESC"] = "DESC";
})(SortDirection || (SortDirection = {}));
//# sourceMappingURL=sortDirection.enum.js.map